import Movie from '@src/resources/Movie';

export const redirect = (basePath: string, id: string, data: any) =>
  `/${Movie.name}/${data.movie_id}/show/prices`;
